import axios from "axios";
import CookieService from "../CookieService";
import { detectMobile, getErrorMessage } from "../utils";
import { setAppLoader } from "../../redux/commonActions";
import { showSnackBar } from "../../components/Snackbar/snackbarActions";
import { EMAIL_ALREADY_USED, STORAGE_ITEMS } from "../constants";

let store;

export const injectStore = _store => {
  store = _store;
};
const customAxios = axios.create({ timeout: 60000 });
const DEVICE_ID = "recDeviceId";
const ACCESS_TOKEN = STORAGE_ITEMS.recAccessToken;
customAxios.interceptors.request.use(
  config => {
    let hasLoader = true;
    let configData = config.data;
    const accessToken =
      CookieService.getCookie(ACCESS_TOKEN) || configData?.token;

    if (config?.loaderConfig?.hasLoader === false) {
      hasLoader = false;
    }
    if (hasLoader && process.browser) {
      store.dispatch(setAppLoader(true));
    }
    if (!config.headers) {
      config.headers = {};
    }
    if (!config.headers.source) config.headers.source = "WEB";
    if (process.browser) {
      config.headers.deviceId =
        CookieService.getCookie(DEVICE_ID) || configData?.deviceId || "";
    }

    if (accessToken && !configData?.noAuthToken) {
      config.headers.authorization = accessToken;
    }
    try {
      config.headers["device-source"] = detectMobile() ? "M-site" : "Desktop";
    } catch (error) {
      config.headers["device-source"] = "Desktop";
    }
    if (configData) {
      delete config.data.reqLang;
      delete config.data.transactionId;
      delete config.data.token;
      delete config.data.noAuthToken;
      delete config.data.deviceId;
    }
    if (config?.method === "get" || config?.method === "GET") {
      delete config.data;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

customAxios.interceptors.response.use(
  response => {
    if (process.browser) store.dispatch(setAppLoader(false));

    return response;
  },
  error => {
    let { params } = error.config || {};
    let { headers = {} } = error?.config?.headers || {};
    if (process.browser) {
      store.dispatch(setAppLoader(false));
      const message = getErrorMessage(error);
      if (
        message?.includes?.(EMAIL_ALREADY_USED.EMAIL_USED_ALREADY) ||
        params?.hideInterceptorMessage ||
        error?.config?.headers?.hideInterceptorMessage ||
        error?.response?.status === 409
      ) {
        console.log("message hidden from interceptor", error);
      } else {
        store.dispatch(
          showSnackBar(
            typeof message === "string"
              ? message || "Something went wrong"
              : "Something went wrong"
          )
        );
      }
    }
    return Promise.reject(error);
  }
);

export default customAxios;
